import xhttp from 'src/utils/xhttp'

const componentGroup = {
    /**
     * 获取分组列表
     *
     * @param {Number} page
     * @param {Number} pageSize
     * @param {String} keyword
     */
    list({ page = 1, pageSize = 10, keyword = '' }) {
        return xhttp.get('/api/dev/component-group/list', { params: { page, pageSize, keyword } })
    },

    /**
     * 分组详细信息
     *
     * @param {*} groupId
     */
    detail(groupId) {
        return xhttp.get(`/api/dev/component-group/detail/${groupId}`)
    },

    /**
     * 增加分组
     *
     * @param {String} params.name
     * @param {String} params.sort
     * @param {String} params.remark
     */
    add(params) {
        return xhttp.post('/api/dev/component-group/add', params)
    },

    /**
     * 更新分组
     *
     * @param {String} params.id
     * @param {String} params.name
     * @param {String} params.sort
     * @param {String} params.remark
     */
    update(params) {
        return xhttp.post('/api/dev/component-group/update', params)
    },

    /**
     * 删除分组
     *
     * @param {String} groupId 分组 id
     */
    delete(groupId) {
        return xhttp.delete(`/api/dev/component-group/${groupId}`)
    }
}

export default componentGroup
